var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.97882,0,0,1.97882,-1769.69,4.00003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1030.49,76.067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.537C-5.168,5.537 -9.371,1.333 -9.371,-3.834C-9.371,-4.367 -9.316,-4.887 -9.231,-5.395L-19.326,-10.419L-11.87,37.007L-58.077,5.939L-97.343,28.096L-53.173,42.206L-69.002,54.088C-68.47,55.263 -68.167,56.563 -68.167,57.934C-68.167,63.101 -72.371,67.305 -77.539,67.305C-82.706,67.305 -86.91,63.101 -86.91,57.934C-86.91,52.766 -82.706,48.563 -77.539,48.563C-75.416,48.563 -73.462,49.28 -71.889,50.475L-63.11,43.885L-108.842,29.276L-60.112,1.78L-54.223,-43.194L-92.025,-16.339L-92.025,-36.865C-96.077,-37.898 -99.085,-41.567 -99.085,-45.935C-99.085,-51.103 -94.881,-55.307 -89.714,-55.307C-84.546,-55.307 -80.342,-51.103 -80.342,-45.935C-80.342,-41.567 -83.351,-37.898 -87.402,-36.865L-87.402,-25.294L-48.264,-53.098L-55.493,2.106L-18.082,27.26L-25.283,-18.548L-7.354,-9.625C-5.636,-11.801 -2.981,-13.205 0,-13.205C5.168,-13.205 9.372,-9.002 9.372,-3.834C9.372,1.333 5.168,5.537 0,5.537M-55.318,-76.067C-98.858,-76.067 -134.153,-40.771 -134.153,2.769C-134.153,46.308 -98.858,81.604 -55.318,81.604C-11.779,81.604 23.517,46.308 23.517,2.769C23.517,-40.771 -11.779,-76.067 -55.318,-76.067",
    style: {
      fill: "rgb(190,124,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,940.776,25.3833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.749,-4.749C-2.131,-4.749 -0,-2.619 -0,-0C-0,2.617 -2.131,4.749 -4.749,4.749C-7.367,4.749 -9.497,2.617 -9.497,-0C-9.497,-2.619 -7.367,-4.749 -4.749,-4.749",
    style: {
      fill: "rgb(190,124,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,1030.49,76.9806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-9.496C2.618,-9.496 4.748,-7.366 4.748,-4.748C4.748,-2.13 2.618,0 0,0C-2.618,0 -4.748,-2.13 -4.748,-4.748C-4.748,-7.366 -2.618,-9.496 0,-9.496",
    style: {
      fill: "rgb(190,124,64)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,952.951,138.749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-9.496C2.618,-9.496 4.748,-7.366 4.748,-4.748C4.748,-2.13 2.618,0 0,0C-2.619,0 -4.748,-2.13 -4.748,-4.748C-4.748,-7.366 -2.619,-9.496 0,-9.496",
    style: {
      fill: "rgb(190,124,64)",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTor);
export default __webpack_public_path__ + "static/media/TOR.ac019302.svg";
export { ForwardRef as ReactComponent };